import './dropzone.css'
import Dropzone from './dropzone.js'

export default Dropzone



//////////////////
// WEBPACK FOOTER
// ./vendor/dropzone/package.js
// module id = lfoN
// module chunks = 40